export const ACTION_ITEM_FOOD = "FOOD";
export const ACTION_ITEM_KIT = "KIT";
export const MEAL_TIMESTAMP = [
  "For Lunch on 16th December, 2023",
  "For Lunch on 15th December, 2023",
  "For Gala Dinner on 16th December, 2023",
  "For Lunch on 17th December, 2023",
  "For Breakfast on 16th December, 2023",
  "For Breakfast on 15th December, 2023",
  "For Breakfast on 17th December, 2023",
  "For Dinner on 15th December, 2023",
];
